import { post } from '@/api/core'

import { MemberLoginReq, MemberLoginRes } from './types'

export type { MemberLoginReq, MemberLoginRes } from './types'

/**
 * 用户登录，如果不存在会自动注册
 * @description https://api.yinnho.cn/api.php?do=member_login&help
 *
 * @param data 请求参数
 */
export function member_login (data: MemberLoginReq) {
  return post<MemberLoginRes>('member_login', data)
}
